import React from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import routes from "../pages/configs";
import NotFound from "../pages/not-found";
import {MainLayout} from "../components/layout";
import {useUser} from "../core/hooks";

const PageRoutes = () => {
    const {user} = useUser()

    return (
        <Router>
            <Routes>
                {routes.map(({Component, Layout, path, secured, footer}, index) => (
                    <Route
                        key={index}
                        path={path}
                        element={
                            secured && !user ? (
                                <Navigate to="/" replace/>
                            ) : (
                                <Layout footer={footer}>
                                    <Component/>
                                </Layout>
                            )
                        }
                    />
                ))}
                <Route
                    path="*"
                    element={
                        <MainLayout>
                            <NotFound/>
                        </MainLayout>
                    }
                />
            </Routes>
        </Router>
    );
}

export default PageRoutes;